import React from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { connectHierarchicalMenu } from 'react-instantsearch-dom';

import { FilterItem } from '../FilterItem';
import useStyles from './styles';

export const HierarchicalMenu = ({ items, refine, isPrimary = true }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <Box className={classes.wrapper}>
        {items && items.length > 0 ? (
          items.map((item) => (
            <div
              className={cx(classes.listItem, !!item.items && classes.expanded)}
              key={item.label}
            >
              <FilterItem
                withArrow={isPrimary}
                label={item.label}
                count={item.count}
                refine={refine}
                isRefined={item.isRefined}
                filterValue={item.label}
                value={item.value}
              />
              {item.items && (
                <div className={classes.sublist}>
                  <HierarchicalMenu items={item.items} refine={refine} isPrimary={false} />
                </div>
              )}
            </div>
          ))
        ) : (
          <div className={classes.noItems}>{t('page.discover.noFiltersAvailable')}</div>
        )}
      </Box>
    </div>
  );
};

export default connectHierarchicalMenu(HierarchicalMenu);
